import React, { useState, useEffect } from "react";
import YotiUboComponent from "../Components/YotiUboComponent";
import Loader from "../Components/Loader";
import isSiteBuilder from "../lib/isSiteBuilder";
import refreshPage from "../lib/refreshPage";

function isItUbbleRedirect() {
  const urlParams = new window.URLSearchParams(window.location.search);
  if (urlParams.get("ubble_identification_id")) return true;
  return false;
}

export default function Yoti_UBO() {
  document.title = "Onboarding";

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(null);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (isItUbbleRedirect()) return setCompleted(true);
    const urlParams = new window.URLSearchParams(window.location.search);
    const AccountID = urlParams.get("account_id");
    const UBO_email = urlParams.get("email").replace(" ","+");

    if (isSiteBuilder()) {
      setTimeout(() => {
        setUrl(
          `https://api.yoti.com/idverify/v1/web/index.html?sessionID=&sessionToken=`
        );
        setLoading(false);
      }, 2000);
      return;
    }

    if (!AccountID || !UBO_email) return;

    window.OrendaGetResponseUnauthenticated(
      {
        event_name: "page load - yoti UBO",
        data: JSON.stringify({ AccountID, UBO_email }),
      },
      (response) => {
        if (response.kyc) {
          if (response.kyc.url) {
            setUrl(response.kyc.url);
            setLoading(false);
            return;
          }
          if (response.kyc.redirect) {
            return (window.location.href = response.kyc.redirect);
          }
        }

        if (response.ubble) {
          return (window.location.href = response.ubble.url);
          // setUrl(response.ubble.url);
          // setLoading(false);
          // return;
        }

        if (response.endeavour) {
          setUrl(response.endeavour.url);
          setLoading(false);
          return;
        }

        const { session_id, client_session_token } = response.yoti;
        setUrl(
          `https://api.yoti.com/idverify/v1/web/index.html?sessionID=${session_id}&sessionToken=${client_session_token}`
        );
        setLoading(false);
      },
      false
    );
    return;
  }, []);

  useEffect(() => {
    async function handleMessage(event) {
      if (
        event.origin === "https://app.shuftipro.com" &&
        event.data.verification_status
      )
        return setCompleted(true);
      if (event.data.message === "Session completed") return setCompleted(true);
      if (event.origin === "https://api.yoti.com") {
        if (event.data.eventType === "SUCCESS") {
          // don't need a fallback as session will only work when connected to the back-end
          return setCompleted(true);
        }
        if (event.data.eventType === "ERROR") {
          if (isSiteBuilder()) return;
          return refreshPage();
        }
      }
      return;
    }

    window.addEventListener("message", handleMessage);

    return async function cleanup() {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (loading) return <Loader />;

  return <YotiUboComponent url={url} completed={completed} />;
}
